import React, { useMemo } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, Label, SimpleItem } from "devextreme-react/form";
import IFournisseur from "../../models/IFournisseur";
import { FormListBase, FormListBaseGrid, FormListBaseTab } from '../base';
import { CheckBox, SelectBox, TextArea, TextBox } from 'devextreme-react';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';

export default function GestionFournisseurs() {
  const fournisseurFormDataSource = useCustomDataSource<IFournisseur, IFournisseur>({ path: "fournisseur", primaryKey: "idFournisseur" });
  const { selectedDataRow: selectedFournisseur, mode, setMode, isFieldModifier, setIsFieldModifier } = fournisseurFormDataSource;

  const provinces = [
    "Ontario", "Québec", "Nouvelle-Écosse", "Nouveau-Brunswick", "Manitoba", "Colombie-Britannique",
    "Île-du-prince-Édouard", "Saskatchewan", "Alberta", "Terre-Neuve-et-Labrador", "Territoires du nord-ouest", "Yukon",
    "Nunavut"
  ];
  const phoneMask = "(NNN) NNN-NNNN";
  const phoneRules = { "N": /[0-9]/ };
  const zipCodeMask = "XNX NXN";
  const zipCodeRules = { "X": /[a-zA-Z]/, "N": /[0-9]/ };

  const { adresseOptions, telOptions, codePostalOptions, villeOptions, telecopieurOptions, courrielOptions, siteWebOptions, numeroTpsOptions, numeroTvqOptions } = useMemo(() => ({
    adresseOptions: { maxLength: 100 },
    telOptions: { maxLength: 16 },
    codePostalOptions: { maxLength: 7 },
    villeOptions: { maxLength: 40 },
    telecopieurOptions: { maxLength: 16 },
    courrielOptions: { maxLength: 60 },
    siteWebOptions: { maxLength: 60 },
    numeroTpsOptions: { maxLength: 30 },
    numeroTvqOptions: { maxLength: 30 }
  }), []);

  return (
    <FormListBase data={fournisseurFormDataSource}>
      <FormListBaseGrid dataSource={fournisseurFormDataSource.dataSource}>
        <Column key={"grid-col-nom"} dataField={"nom"} caption="Nom" allowHiding={false} />
        <Column key={"grid-col-prenom"} dataField={"prenom"} caption="Prénom" allowHiding={false} />
        <Column key={"grid-col-adresse"} dataField={"adresse"} caption="Adresse" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseTab>
        <TabItem title="Informations">
          <div style={{ display: "flex" }}>
            <div style={{ width: "50%" }}>
              <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedFournisseur || {} as IFournisseur} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                <SimpleItem key={"fournisseur"}>
                  <Label text={"Fournisseur"} />
                  <TextBox defaultValue={"3096 2575 Québec inc."} />
                </SimpleItem>
                <SimpleItem key={"adresse"} editorOptions={
                  adresseOptions
                }>
                  <Label text={"Adresse"} />
                  <TextBox defaultValue={"C.P. 544"} />
                </SimpleItem>
                <GroupItem colCount={2}>
                  <SimpleItem key={"code-postal"} editorOptions={
                    codePostalOptions
                  }>
                    <Label text={"Code postal"} />
                    <TextBox defaultValue={"J9E3K6"} mask={zipCodeMask} maskRules={zipCodeRules} />
                  </SimpleItem>
                  <SimpleItem key={"ville"} editorOptions={
                    villeOptions
                  }>
                    <Label text={"Ville"} />
                    <TextBox defaultValue={"Maniwaki"} />
                  </SimpleItem>
                </GroupItem>
                <SimpleItem key={"province"}>
                  <Label text={"Province"} />
                  <SelectBox items={provinces} defaultValue={provinces[1]} />
                </SimpleItem>
                <SimpleItem key={"tel"} editorOptions={
                  telOptions
                }>
                  <Label text={"Téléphone"} />
                  <TextBox defaultValue={"8194412525"} mask={phoneMask} maskRules={phoneRules} />
                </SimpleItem>
                <SimpleItem key={"telecopieur"} editorOptions={
                  telecopieurOptions
                }>
                  <Label text={"Télécopieur"} />
                  <TextBox mask={phoneMask} maskRules={phoneRules} />
                </SimpleItem>
                <SimpleItem key={"courriel"} editorOptions={
                  courrielOptions
                }>
                  <Label text={"Courriel"} />
                  <TextBox />
                </SimpleItem>
                <SimpleItem key={"site-web"} editorOptions={
                  siteWebOptions
                }>
                  <Label text={"Site web"} />
                  <TextBox />
                </SimpleItem>
                <SimpleItem key={"fournisseur-paiement"}>
                  <Label text={"Fournisseur paiement"} />
                  <TextBox />
                </SimpleItem>
                <SimpleItem key={"folio-compte-a-payer"}>
                  <Label text={"Folio compte à payer"} />
                  <TextBox defaultValue={"Aucun - Aucun"} />
                </SimpleItem>
                <SimpleItem key={"folio-transport"}>
                  <Label text={"Folio transport"} />
                  <TextBox defaultValue={"Aucun - Aucun"} />
                </SimpleItem>
                <SimpleItem key={"mode-paiement-par-defaut"}>
                  <Label text={"Mode de paiement par défaut"} />
                  <TextBox defaultValue={"Aucun"} />
                </SimpleItem>
                <SimpleItem key={"actif"}>
                  <Label text={"Actif"} />
                  <CheckBox value={true} />
                </SimpleItem>
                <GroupItem caption={"Folios"}>
                  <GroupItem>
                    <DataGrid showBorders={true} allowColumnResizing={true}>
                      <Column caption={"Folio"} />
                      <Column caption={"Escompte"} />
                    </DataGrid>
                  </GroupItem>
                </GroupItem>
              </Form>
            </div>
            <div style={{ width: "50%" }}>
              <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedFournisseur || {} as IFournisseur} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                <GroupItem caption={"Dépôt"}>
                  <SimpleItem key={"transit"}>
                    <Label text={"Transit"} />
                    <TextBox />
                  </SimpleItem>
                  <SimpleItem key={"folio"}>
                    <Label text={"Folio"} />
                    <TextBox />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption={"Escomptes"}>
                  <SimpleItem key={"nb-de-jours-net"}>
                    <Label text={"Nb. de jours net"} />
                    <TextBox defaultValue={"30"} />
                  </SimpleItem>
                  <SimpleItem key={"escompte"}>
                    <Label text={"Escompte"} />
                    <TextBox defaultValue={"0.000"} />
                  </SimpleItem>
                  <SimpleItem key={"jours-escompte"}>
                    <Label text={"Jours escompte"} />
                    <TextBox defaultValue={"0"} />
                  </SimpleItem>
                  <SimpleItem key={"escompte-apres-escompte"}>
                    <Label text={"Escompte après escompte"} />
                    <TextBox defaultValue={"0.000"} />
                  </SimpleItem>
                  <SimpleItem key={"calculer-escompte"}>
                    <CheckBox text={"Calculer escompte sur montant avant taxes"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption={"Taxes"}>
                  <SimpleItem key={"numero-tps"} editorOptions={
                    numeroTpsOptions
                  }>
                    <Label text={"No. TPS"} />
                    <TextBox />
                  </SimpleItem>
                  <SimpleItem key={"numero-tvq"} editorOptions={
                    numeroTvqOptions
                  }>
                    <Label text={"No. TVQ"} />
                    <TextBox />
                  </SimpleItem>
                  <GroupItem colCount={2}>
                    <SimpleItem key={"paie-tps"}>
                      <CheckBox text={"Paie TPS"} value={true} />
                    </SimpleItem>
                    <SimpleItem key={"paie-tvq"}>
                      <CheckBox text={"Paie TVQ"} value={true} />
                    </SimpleItem>
                  </GroupItem>
                </GroupItem>
                <GroupItem caption={"Informations complémentaires"}>
                  <SimpleItem key={"pourcentage-profit"}>
                    <Label text={"% de profit de vente"} />
                    <TextBox defaultValue={"0.00"} />
                  </SimpleItem>
                  <SimpleItem key={"solde"}>
                    <label style={{ marginRight: "0.5em" }}>Solde:</label>
                    <label>0.00$</label>
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption={"Notes"}>
                  <TextArea height={200} />
                </GroupItem>
              </Form>
            </div>
          </div>
        </TabItem>
        <TabItem title="Contacts">
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedFournisseur || {} as IFournisseur} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <GroupItem>
              <DataGrid showBorders={true} allowColumnResizing={true}>
                <Column caption={"Contact"} />
                <Column caption={"Téléphone"} />
                <Column caption={"Ext."} />
                <Column caption={"Type de téléphone"} />
                <Column caption={"Courriel"} />
              </DataGrid>
            </GroupItem>
          </Form>
        </TabItem>
        <TabItem title="Achats">
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedFournisseur || {} as IFournisseur} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <GroupItem>
              <DataGrid showBorders={true} allowColumnResizing={true}>
                <Column caption={"Description"} />
                <Column caption={"Date d'achat"} />
                <Column caption={"Montant"} />
              </DataGrid>
            </GroupItem>
          </Form>
        </TabItem>
        <TabItem title="Déboursés">
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedFournisseur || {} as IFournisseur} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <GroupItem>
              <DataGrid showBorders={true} allowColumnResizing={true}>
                <Column caption={"No. facture"} />
                <Column caption={"Date achat"} />
                <Column caption={"Date déboursé"} />
                <Column caption={"Montant facture"} />
                <Column caption={"Escompte"} />
                <Column caption={"Déboursé"} />
              </DataGrid>
            </GroupItem>
          </Form>
        </TabItem>
        <TabItem title="Montant à payer">
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedFournisseur || {} as IFournisseur} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <GroupItem>
              <DataGrid showBorders={true} allowColumnResizing={true}>
                <Column caption={"No. facture"} />
                <Column caption={"Date achat"} />
                <Column caption={"Échéance facture"} />
                <Column caption={"Échéance escompte"} />
                <Column caption={"Montant facture"} />
                <Column caption={"Montant déboursé"} />
                <Column caption={"Montant escompte"} />
                <Column caption={"Montant à payer"} />
              </DataGrid>
            </GroupItem>
          </Form>
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedFournisseur || {} as IFournisseur} /></TabItem>
      </FormListBaseTab>
    </FormListBase>
  );
}
